import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { useExtendedLogger } from '../Logger';

import { DEFAULT_LOCALE, LOGGER_NAME } from './constants';
import type { TLocaleContext } from './types';
import { addDummyLocaleData } from './helpers';

const Context = React.createContext<TLocaleContext>({
  currentLanguage: DEFAULT_LOCALE,
  changeLanguage: () => null,
});

function Provider({
  children,
  locale: initialLocale = DEFAULT_LOCALE,
}: {
  children: React.ReactNode;
  locale?: string;
}) {
  const log = useExtendedLogger(LOGGER_NAME);

  const [locale, setLocale] = useState(initialLocale);

  const changeLanguage = useCallback((locale: string) => {
    addDummyLocaleData(locale);
    setLocale(locale);
  }, []);

  const context = useMemo(
    () => ({
      changeLanguage,
      currentLanguage: locale,
    }),
    [changeLanguage, locale]
  );

  useEffect(() => addDummyLocaleData(locale), [locale]);

  log('adding locale provider with context %o', context);

  return <Context.Provider value={context}>{children}</Context.Provider>;
}

export { Context, Provider };
